import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';

import DownloadGroupToast from '../../components/DownloadGroupToast';
import DownloadManagerUtils from '../../utils/downloadManager';
import {
	DownloadGroupName,
	DownloadGroupStatus,
} from '../DownloadManager/reducer';

const mapStateToProps = (state: StoreState) => {
	const {
		downloadManager,
		downloadManager: {
			isDownloadToastClosed,
			downloadGroups,
			pendingSelectedDownloads,
			totalSelectedDownloadsCount,
		},
		driveList,
		galleryInfos,
	} = state;
	const { config } = galleryInfos;
	const applicationGallery = config && config.applicationGallery;
	const importantAssets = config && config.importantAssets;
	const isGalleryConfigReady = !!applicationGallery;

	const pendingSelectedDownloadsCount = Object.keys(pendingSelectedDownloads).length;

	const isDownloadGroupStarted = [
		downloadGroups.all.status,
		downloadGroups.important.status,
		downloadGroups.selected.status,
	].includes(DownloadGroupStatus.Started);
	const enabledImportantTags = DownloadManagerUtils.getEnabledImportantTags(importantAssets);

	const downloadingGroup = DownloadManagerUtils.getDownloadingGroup(downloadGroups);
	const startedDownloadGroup = DownloadManagerUtils.getStartedDownloadGroup(downloadGroups);
	const isPausedDownloadAll = downloadGroups.all.status === DownloadGroupStatus.Started
		&& startedDownloadGroup === DownloadGroupName.ALL
		&& downloadingGroup !== DownloadGroupName.ALL;

	let loaderStepTagParam: string[] = [];
	let showGalleryLoaderProgress = false;

	if (downloadingGroup === DownloadGroupName.IMPORTANT) {
		loaderStepTagParam = enabledImportantTags;
		showGalleryLoaderProgress = true;
	} else if (downloadingGroup === DownloadGroupName.ALL || isPausedDownloadAll) {
		showGalleryLoaderProgress = true;
	}

	const loaderStep = isGalleryConfigReady && showGalleryLoaderProgress
		? DownloadManagerUtils.getGalleryLoaderStep(
			downloadManager,
			driveList,
			applicationGallery,
			true,
			loaderStepTagParam
		)
		: undefined;
	const isDownloadingSelectedGroup = downloadingGroup === DownloadGroupName.SELECTED;

	let downloadedCount: number;
	let totalCount: number;

	if (isDownloadingSelectedGroup) {
		downloadedCount = totalSelectedDownloadsCount - pendingSelectedDownloadsCount;
		totalCount = totalSelectedDownloadsCount;
	} else if (loaderStep) {
		downloadedCount = loaderStep.itemsDownloaded;
		totalCount = loaderStep.itemsToDownload;
	} else {
		downloadedCount = 0;
		totalCount = 0;
	}

	// Keep visible while the download group is Started (through backfill/repair until finishDownloadGroup).
	const isDisplayed = isDownloadGroupStarted && !isDownloadToastClosed;

	return {
		isDisplayed,
		downloadedItems: downloadedCount,
		totalItems: totalCount,
		startedDownloadGroup,
		isCheckingForUpdates: totalCount > 0 && totalCount === downloadedCount
			&& !isDownloadingSelectedGroup && isDownloadGroupStarted,
	};
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
	dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadGroupToast);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DownloadGroupToast/index.tsx